import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/producer/importer/producerImporterSelectors';
import ProducerService from 'src/modules/producer/producerService';
import fields from 'src/modules/producer/importer/producerImporterFields';
import { i18n } from 'src/i18n';

const producerImporterActions = importerActions(
  'PRODUCER_IMPORTER',
  selectors,
  ProducerService.import,
  fields,
  i18n('entities.producer.importer.fileName'),
);

export default producerImporterActions;